<template>
    <div class="profile-function-card d-flex justify-content-between align-items-center px-5" style="max-width: 100%">
        <div class="d-flex justify-content-center align-items-center gap-4">
            <span class="weight-600 font-16"> Slide{{ profileFunction.index + 1 }} </span>
            <!-- <img
                v-if="profileFunction.file_id.toLowerCase().endsWith('.mp4')"
                src="@/assets/px/mobex-health-plus-dashboard/video.svg"
                alt="video"
                title="video"
                height="30"
                width="40"
            />
            <img
                v-else
                src="@/assets/px/mobex-health-plus-dashboard/image.svg"
                alt="Image"
                title="Image"
                height="30"
                width="40"
            /> -->
            <ejs-tooltip
                class="tooltipcontainer"
                :content="profileFunction.description"
                target="#target"
                cssClass="customtooltip"
            >
                <span
                    id="target"
                    class="profile-function-card-label me-3 cursor-pointer profile-function-card-name w-100"
                >
                    {{ profileFunction.description }}
                </span>
            </ejs-tooltip>
        </div>
        <div class="d-flex justify-content-center align-items-center gap-4">
            <Toggle
                :id="profileFunction.description"
                class="toggle-switch"
                labelClass="switch"
                spanClass="slider"
                :value="profileFunction.is_active"
                :disabled="disableToggle"
                @input="(value) => handleToggle(value, profileFunction)"
            />
            <div class="d-flex justify-content-center align-items-center gap-3">
                <ejs-tooltip class="tooltipcontainer" content="Edit" target="#edit-target" cssClass="customtooltip">
                    <img
                        :id="'edit-target'"
                        src="@/assets/px/edit-icon.png"
                        alt="Edit"
                        style="height: 20px"
                        :class="disableBtn ? 'btn-disabled' : 'cursor-pointer'"
                        @click="!disableBtn && (showIntroSlidesEditModal = true)"
                    />
                </ejs-tooltip>

                <ejs-tooltip class="tooltipcontainer" content="Delete" target="#delete-target" cssClass="customtooltip">
                    <img
                        :id="'delete-target'"
                        src="@/assets/px/delete-icon.png"
                        alt="Delete"
                        style="height: 20px"
                        :class="disableBtn ? 'btn-disabled' : 'cursor-pointer'"
                        @click="!disableBtn && (showIntroSlideDeleteModal = true)"
                    />
                </ejs-tooltip>
            </div>
        </div>
        <EditIntroSlideModal
            v-if="showIntroSlidesEditModal"
            :profileFunction="profileFunction"
            @handleDelete="handleDelete"
            @save="handleIntroSlide"
            @cancel="showIntroSlidesEditModal = false"
        />
        <DeleteIntroSlide
            v-if="showIntroSlideDeleteModal"
            @handleDelete="handleDelete"
            @cancel="showIntroSlideDeleteModal = false"
        />
    </div>
</template>

<script>
    import EditIntroSlideModal from './EditIntroSlideModal.vue';
    import DeleteIntroSlide from './DeleteIntroSlide.vue';

    export default {
        name: 'IntroSlideCard',
        components: { EditIntroSlideModal, DeleteIntroSlide },
        props: {
            profileFunction: {
                type: Object,
                required: true,
            },
            disableActiveIntroSlides: {
                type: Boolean,
            },
            disableBtn: {
                type: Boolean,
            },
        },
        data() {
            return {
                showIntroSlidesEditModal: false,
                showIntroSlideDeleteModal: false,
            };
        },
        computed: {
            disableToggle() {
                return !this.profileFunction.is_active && this.disableActiveIntroSlides;
            },
        },
        methods: {
            handleToggle(value, profileFunction) {
                this.$emit('onToggle', { value, profileFunction });
            },
            handleIntroSlide(data) {
                this.showIntroSlidesEditModal = false;
                this.$emit('handleIntroSlide', data);
            },
            handleDelete() {
                this.showIntroSlideDeleteModal = false;
                this.$emit('handleDelete', this.profileFunction);
            },
        },
    };
</script>

<style scoped>
    .profile-function-card-name {
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        color: #373cbb;
        text-transform: capitalize;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        max-width: 60rem;
    }

    .btn-disabled {
        cursor: not-allowed;
        opacity: 0.8;
    }
</style>
